import { SingleCooperative } from "../../redux/features/cooperative/cooperative.type";
import { Icon } from "../icons/icon";

export const CooperativeMemberCount = ({
  cooperative,
  className = "",
}: {
  cooperative: SingleCooperative;
  className?: string;
}) => {
  return (
    <p
      className={`
        w-fit text-xs text-white
        font-medium py-1 px-2 rounded-full
        bg-pry-green-200 flex flex-row flex-wrap
        items-center gap-1 ${className}
        `}
    >
      <Icon svg="people" width={14} height={14} />
      {cooperative?.membercount}{" "}
      {cooperative?.membercount === 1 ? "member" : "members"}
    </p>
  );
};
